<script setup>
// The club's logo as the club made it: its own shape, no background behind it,
// corners only barely rounded. A club without one shows its initials.
const props = defineProps({
  filename: {type: String, default: null},
  clubName: {type: String, default: ''},
  size: {type: Number, default: 60},
});

const {uploadFilenameToUrl} = useCrudConverters();
const initials = computed(() => props.clubName
    .split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase());
</script>

<template>
  <img v-if="filename" :src="uploadFilenameToUrl(filename, size > 120 ? 'large' : 'medium')" :alt="clubName"
       class="tv-logo" :style="{height: size + 'px', maxWidth: size * 2 + 'px'}">
  <span v-else class="tv-logo tv-logo--initials" :style="{width: size + 'px', height: size + 'px', fontSize: size * 0.38 + 'px'}">
    {{ initials }}
  </span>
</template>

<style scoped lang="scss">
.tv-logo {
  display: block;
  flex-shrink: 0;
  width: auto;
  object-fit: contain;
  border-radius: 6px;
}

.tv-logo--initials {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tv-chip);
  color: var(--tv-ink);
  font-weight: 700;
}
</style>
